'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {VegetableDiary} from 'components';


var tooltip = _react2.default.createElement(
  ReactBootstrap.Tooltip,
  { id: 'tooltip' },
  'Click on download to download the PDF.'
);

var Module1Res2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Res2, _Component);

  function Module1Res2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Res2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Res2.__proto__ || (0, _getPrototypeOf2.default)(Module1Res2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Vegetable Providing Diary'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module1Res2, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      var day1 = require('./Assets/day1.png');
      var day2 = require('./Assets/day2&day3.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 1'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, sm: 12, lg: 12, xs: 12 },
                _react2.default.createElement(
                  'p',
                  null,
                  'The more parents offer vegies to children, the more likely they are to eat them over time even if they say no.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'For that reason, it is a good idea to record how often you offer vegetables over the next week. Try to record 2 weekdays and 1 day over the weekend.'
                ),
                _react2.default.createElement('div', { className: styles.spacer40 })
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { xs: 6, md: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Thumbnail,
                  { src: day1, alt: '242x200' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Day 1'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Diary for day 1. Includes an example of how to fill out your vegetable providing diary.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'a',
                      { href: '/Assets/day1.pdf', download: true },
                      _react2.default.createElement(
                        ReactBootstrap.Button,
                        { bsStyle: 'success' },
                        'Download'
                      ),
                      '\xA0'
                    ),
                    '\xA0 \xA0',
                    _react2.default.createElement(
                      ReactBootstrap.OverlayTrigger,
                      { placement: 'right', overlay: tooltip },
                      _react2.default.createElement('i', { className: 'fa fa-question-circle fa-lg', 'aria-hidden': 'true' })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { xs: 6, md: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Thumbnail,
                  { src: day2, alt: '242x200' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Day 2 & Day 3'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Diary for day 2 and day 3.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'a',
                      { href: '/Assets/day2&day3.pdf', download: true },
                      _react2.default.createElement(
                        ReactBootstrap.Button,
                        { bsStyle: 'success' },
                        'Download'
                      )
                    ),
                    '\xA0 \xA0',
                    _react2.default.createElement(
                      ReactBootstrap.OverlayTrigger,
                      { placement: 'right', overlay: tooltip },
                      _react2.default.createElement('i', { className: 'fa fa-question-circle fa-lg', 'aria-hidden': 'true' })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 })
          )
        )
      );
    }
  }]);
  return Module1Res2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Res2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/1/Res2.js
// module id = 1235
// module chunks = 0